import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import CloseCircle from "../../components/Buttons/CloseCircle";
import Column from "../../components/Column/Column";
import { Modal } from "../../components/Modal/Modal";
import Row from "../../components/Row/Row";
import Text from "../../components/Text/Text";
import close_circle from '../../imgs/close-circle.svg';
import license_owners_icon from "../imgs/license_owner_icon.svg";
import license_type_icon from "../imgs/license_type_icon.svg";

interface ManageLicensesProps {
  theme: string;
}

const ManageLicenseContainer = styled.div`
  position: relative;
  background: #000d30;
  width: 50%;
  min-height: 70vh;
  border-radius: 20px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(31, 29, 107, 0.49);
  min-height: 20vh;
  min-width: 10vw;
  padding-inline: 3%;
  padding-top: 1%;
  border: 1px solid #ffffff90;
  border-radius: 15px;

  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
`;

const TitleText = styled(Text)`
  width: 100%;
  position: absolute;
  font-weight: 500;
  font-size: 28px;
  top: 10%;
  left: 3%;
  margin-right: 10px;
  margin-top: 10px;
`;

export const ManageLicensesModal: React.FC<ManageLicensesProps> = ({
  theme,
}) => {
  const navigate = useNavigate();
  const ref = useRef();

  const onLicenseTypeClick = () => {
    navigate("license_types");
  };
  const onLicenseOwnersClick = () => {
    navigate("license_owners");
  };

  const onCloseClick = () => {
    navigate("..");
  };

  return (
    <Modal ref={ref} show={true}>
      <ManageLicenseContainer>
        <CloseCircle onClick={onCloseClick} bg={close_circle} />
        <Column>
          <TitleText>Manage Licenses</TitleText>

          <Row gap="5%" style={{marginTop: 'auto', }}>
            <Card onClick={onLicenseTypeClick}>
              <img src={license_type_icon} />
              <Text>License Type</Text>
            </Card>

            <Card onClick={onLicenseOwnersClick}>
              <img src={license_owners_icon} />
              <Text>License Owners</Text>
            </Card>
          </Row>
        </Column>
      </ManageLicenseContainer>
    </Modal>
  );
};
